"use strict";

var _createClass = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Deferred = void 0;

var Deferred = /*#__PURE__*/_createClass(function Deferred() {
  var _this = this;

  _classCallCheck(this, Deferred);

  this.resolve = function () {
    return null;
  };

  this.reject = function () {
    return null;
  };

  this.promise = new Promise(function (resolve, reject) {
    _this.reject = reject;
    _this.resolve = resolve;
  });
});

exports.Deferred = Deferred;